<template>
  <div class="row justify-content-center no-gutters mb-5 mb-lg-0">
    <div class="col-lg-6">
      <a :href="project.coverImage" data-toggle="lightbox" :data-gallery="project.key">
        <img class="img-fluid" :src="project.coverImage" :alt="t(project.altKey)" />
      </a>
      <div
        v-for="img in project.images"
        :key="img"
        data-toggle="lightbox"
        :data-gallery="project.key"
        :data-remote="img"
      ></div>
    </div>
    <div class="col-lg-6" :class="{ 'order-lg-first': !project.imageOnLeft }">
      <div class="bg-black text-center h-100 project">
        <div class="d-flex h-100">
          <div
            class="project-text w-100 my-auto text-center"
            :class="project.imageOnLeft ? 'text-lg-left' : 'text-lg-right'"
          >
            <h4 class="text-white">{{ t(project.titleKey) }}</h4>
            <p class="mb-0 text-white-50" v-html="t(project.bodyKey)"></p>
            <hr class="d-none d-lg-block mb-0" :class="project.imageOnLeft ? 'ml-0' : 'mr-0'" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  project: {
    type: Object,
    required: true,
  },
})
</script>
